export const ErrorCode = {
  INVALID_PARAMETER: "0001",
  INVALID_ID: "2005",
  INVALID_PASSWORD: "2006",
} as const

export type ErrorCode = (typeof ErrorCode)[keyof typeof ErrorCode]

/**
 * 서버가 거절 사유로 내려준 **사람이 읽을 문장**을 뽑는다. 없으면 null.
 *
 * 🚨 응답의 `message` 를 그대로 쓰면 안 된다 — 그 값은 Grape 에러의 **클래스명**이라
 * 화면에 "NotAcceptable" 이 그대로 떴다(PARTNER-FRONTEND-XT: 판매중지 계정으로
 * 로그인하면 사용자는 뜻을 알 수 없는 영문 한 덩어리만 봤다). 진짜 사유는
 * `extra.guide` 에만 있다.
 *
 * `extra` 가 문자열인 모양("duplicate_name" 등)은 일부러 제외한다 — 그건 내부 코드명이지
 * 사용자에게 보여줄 문장이 아니다.
 */
export function apiGuideMessage(data: any): string | null {
  const guide = data?.extra?.guide
  if (typeof guide === "string" && guide.trim()) return guide.trim()
  return null
}

/**
 * 서버가 400 InvalidParameter(0001) 로 거절한 사유를 사용자에게 보여줄 문장으로 만든다.
 *
 * 🚨 원래는 0001 이면 무조건 "이미 존재하는 상품명입니다" 를 띄웠다. 그런데 0001 은
 * 상품명 중복 말고도 여러 검증에 쓰인다 — 실제로 2026-08-07 에 어떤 파트너가
 * `contents sum of ratio must be 100`(혼용률 합계 오류) 로 거절당했는데 화면에는
 * **"이미 존재하는 상품명입니다"** 가 떴다. 사유를 못 찾으니 고칠 수도 없었다.
 *
 * 응답은 두 모양으로 온다:
 *   { code: "0001", extra: "duplicate_name" }                        → 상품명 중복
 *   { code: "0001", extra: { guide: "...", reason: [...] } }         → guide 가 사유
 *
 * guide 는 영문이라 완벽하진 않지만, 틀린 안내보다 낫다.
 */
export function invalidParameterMessage(data: any, messages: { duplicateName: string; unknown: string }): string {
  const extra = data?.extra

  if (extra === "duplicate_name") return messages.duplicateName

  const guide = typeof extra === "string" ? extra : extra?.guide
  if (typeof guide === "string" && guide.trim()) return guide.trim()

  return messages.unknown
}
